import { Alert, Stack, Typography } from "@mui/material";
import useProducts from "../utils/useProducts";
import useCart from "../utils/useCart";
import { Redeem } from "@mui/icons-material";
import moment from "moment";

export default function LearnyDaysAlert(){

    const { data: products } = useProducts();

    const { cart } = useCart();

    const showLearnyDaysOffer = cart.category === 'dentaire' && 
        !!products?.find(p => p.variant.id.startsWith( 'dpc')) &&
        moment().valueOf() < moment('2025-03-16T23:59:59.999');

    if (!showLearnyDaysOffer) return <></>;
 
    return (
        <Stack gap={0.5} sx={{ maxWidth: 700 }}>
            <Alert severity="warning" icon={<Redeem />}>
                <Typography align="center">
                    <b>Offre LEARNYDAYS :</b> jusqu'à dimanche 16/04 seulement, pour 1 inscription DPC réalisée* = 1 formation clinique offerte** ou -20% sur la MasterClass de votre choix
                </Typography>
            </Alert>
            <Typography variant="body2" color="text.secondary" align="center">*offre limitée à 1 inscription DPC par personne</Typography>
            <Typography variant="body2" color="text.secondary" align="center">**hors formations réglementaires et gestion cabinet</Typography>
        </Stack>
    );
}